import { FC } from 'react';

import style from './Input.module.scss';

type TInputProps = {
	title: string;
	placeholder?: string;
	value: string;
	onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
	type: string;
	readOnly?: boolean;
	required?: boolean;
	id: string;
	maxLength?: number;
};

const Input: FC<TInputProps> = ({ id, title, ...props }) => {
	return (
		<div className={style['input-element']}>
			<label htmlFor={id}>{title}</label>
			<input id={id} name='input' {...props} autoComplete='off' />
		</div>
	);
};

export default Input;
